import { addClass, removeClass } from '@studiometa/js-toolkit/utils';
import { Panel } from '@studiometa/ui';

/**
 * Preparation
 */
export default class PreparationPanel extends Panel {
  /**
   * Config
   */
  static config = {
    ...Panel.config,
    name: 'PreparationPanel',
    refs: ['close[]', 'container', 'content', 'modal', 'overlay', 'stepContent[]'],
    options: {
      ...Panel.config.options,
    },
  };

  /**
   * mounted
   */
  mounted() {
    this.$refs.stepContent.forEach((item) => {
      addClass(item, 'hidden');
    });
  }

  /**
   * open()
   * @param {number} index
   */
  open(index) {
    super.open();
    this.$refs.stepContent.forEach((item) => {
      addClass(item, 'hidden');
    });
    removeClass(this.$refs.stepContent[index], 'hidden');
  }
}
